import React, {useState,useEffect} from 'react'
import {
	useDispatch,
	useSelector
} from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Webcam from "react-webcam"
import {createProgressPicture,getPicturesByDate} from '../photoReel/photoReelSlice'
import {fullBasePath,dateToYMD} from '../../util/util'
import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import {toggleShow,setPose,setDate} from './poseCamSlice'
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";

const PoseCam = props =>{
	const dispatch = useDispatch()
	const date = useSelector(state=>state.poseCam.date)
	//available modes 'capture' || 'confirm'
	const [mode,setMode] = useState('capture')
	const [imageToConfirm,setImageToConfirm] = useState(null)
	const currentPose = useSelector(state=>state.poseCam.currentPose)
	const overlays = [
		'ImageOverlayFront.png',
		'ImageOverlaySide.png',
		'ImageOverlayBack.png'
	]
	const overlaySrc = (
		currentPose === 0 ? null :
		`${fullBasePath()}/assets/img/overlays/${overlays[currentPose-1]}`
	)
	const webcamRef = React.useRef(null)

	const user_id = useSelector(state=>state.users.current_user.user_id_number)
	const isTrainer = useSelector(state => state.users.current_user.account_type) === 'trainer'
	const url = new URL(window.location.href);
	const clientId = url.searchParams.get("client");
	const trainerId = url.searchParams.get("trainer");

	const statusDispatch = useApiStatusDispatch();

	const {
		file:upload,
		processUpload,
		setUpload,
		clearUpload
	} = useS3DirectUpload()

	const show = useSelector(state=>state.poseCam.show)
	const IDLE = 'idle'
	const [countDown,setCountDown] = useState(IDLE)
	const saveImage = async ()=>{
		let client_id;
		if(isTrainer){
			client_id=clientId
		} else {
			client_id=user_id
		}
		const s3Res = await processUpload()
		if(s3Res.success){
			const payload = {
				client_id,
				caption:'caption',
				img:s3Res.payload.url,
				type:currentPose,
				otherType:currentPose,
				date:dateToYMD(new Date(date))
			}
			statusDispatch(createProgressPicture(payload), "picture", "create")
			setMode('capture')
			setImageToConfirm(null)
			if([1,2].includes(currentPose)){
				dispatch(setPose(currentPose+1))
			}else{
				dispatch(toggleShow(false))
			}
		}
	}
	const capture = () => {
		if(!webcamRef.current) return
		const canvas = webcamRef.current.getCanvas()
		if(!canvas) return
		canvas.toBlob(async (blob)=>{
			setImageToConfirm(blob)
			setUpload( await new File([blob],`image.jpeg`,{type:"image/jpeg"}))
			setMode('confirm')
		})//end toBlob
	}
	const retake = () => {
		setMode('capture')
		setImageToConfirm(null)
	}
	useEffect(()=>{
		if(countDown === IDLE) return
		if(countDown===-1){
			capture()
			setCountDown(IDLE)
		}else{
			const timer = setTimeout(() => {
				setCountDown(countDown-1)
			}, 1200);
			// Clear timeout if the component is unmounted
			return () => clearTimeout(timer);
		}
	})
	const camRelativeWidth = window.innerWidth >= 800 ? 60 : 100
	return (
		<Modal centered size="lg" show={show} onHide={()=>dispatch(toggleShow(false))}>
			<Modal.Header closeButton>
				<Modal.Title>Fit Cam</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="mb-2 d-flex justify-content-center align-items-center flex-wrap">
					<ButtonGroup aria-label="Basic example" className="m-1">
						<Button
							size="sm" 
							onClick={()=>{dispatch(setPose(1))}}
							variant={currentPose===1?'primary':'outline-primary'}>
							Front
						</Button>
						<Button
							size="sm" 
							onClick={()=>{dispatch(setPose(2))}}
							variant={currentPose===2?'primary':'outline-primary'}>
							Side
						</Button>
						<Button
							size="sm" 
							onClick={()=>{dispatch(setPose(3))}}
							variant={currentPose===3?'primary':'outline-primary'}>
							Back
						</Button>
						<Button
							size="sm" 
							onClick={()=>{dispatch(setPose(0))}}
							variant={currentPose===0?'primary':'outline-primary'}>
							Other
						</Button>
					</ButtonGroup>
					<DatePicker 
						className="m-1"
						selected={new Date(date)}
						onChange={date => dispatch(setDate(
							new Date(date).toLocaleString()
						))} />
				</div>
				<div style={{
					margin:'auto',
					position:'relative',
					width:`${camRelativeWidth}%`,
					height:0,
					paddingBottom:`${(1667/1252)*camRelativeWidth}%`
				}}>
					<div style={{
						position:'absolute',
						top:0,
						left:0,
						width:'100%',
						height:'100%',
						overflow:'hidden'
					}}>
						<Webcam
							style={{
								position:'absolute',
								top:0,
								left:'50%',
								transform:'translateX(-50%)'
							}}
							videoConstraints={{aspectRatio: 1252/1667}}
							width="100%"
							height={`100%`}
							ref={webcamRef}
							audio={false}/>
						{
							mode === 'confirm' &&
							<img 
								style={{
									position:'absolute',
									top:0,
									left:'50%',
									transform:'translateX(-50%)',
									width:'100%',
									height:'100%',
									display:'block'
								}} 
								src={URL.createObjectURL(imageToConfirm)}/>
						}
						{currentPose!==0&&
							<img 
								src={overlaySrc} 
								style={{
									position:'absolute',
									top:0,
									left:0,
									height:'100%'
								}}/>
						}
						{countDown!==IDLE?
							<div style={{
								position:'absolute',
								top:0,
								right:0,
								fontSize:'24px',
								background:'rgba(0,0,0,0.4)',
								color:'#fff',
								padding:'8px 16px'
							}}>
								{countDown >= 0 ? countDown : 0}
							</div>
						:null}
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer>
				{
					mode === 'capture' ?
					<Button 
						variant="outline-success" 
						block 
						onClick={()=>setCountDown(3)}>
						Start Countdown
					</Button>:
					<div className="d-flex justify-content-between">
						<Button className="mr-2" variant="outline-secondary" onClick={retake}>
							Retake
						</Button>
						<Button variant="outline-success" onClick={saveImage}>
							Save
						</Button>
					</div>
				}
			</Modal.Footer>
		</Modal>
	)
}

export default PoseCam